import React from "react";
import Link from "next/link";
import Image from "next/image";

export const LeadershipCard = ({
	slug,
	imageSrc,
	alt,
	name,
	designation,
	excerpt,
	linkedin = true,
}) => {
	return (
		<Link href={`/leadership/${slug}`} className="flex flex-col justify-end items-start box-shadow rounded-[20px] text-left bg-white group text-white relative min-h-[300px] lg:min-h-[400px] overflow-hidden group w-full border-2 border-white hover:border-primary">
			<div className="flex flex-col gap-2 py-12 px-8 z-20 text-center transition-all duration-500 items-center w-full leaderdetailsvs">
				<h4 className="text-[24px] lg:text-[30px] font-normal leading-[24px] lg:leading-[28px]">{name}</h4>
				<h6 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-light">{designation}</h6>
			</div>
			<div className="absolute h-full w-full bg-black bg-opacity-30 z-10 top-0 left-0"></div>
			<Image alt={alt} src={imageSrc} width={100} height={80} unoptimized className="w-full h-full object-cover object-top absolute top-0 left-0" />
		</Link>
	);
};
